import { Lenker } from '@gsm/entities';
import { DYNAMIC_FORM_CONTROL_TYPE_DATEPICKER, DYNAMIC_FORM_CONTROL_TYPE_GROUP, DYNAMIC_FORM_CONTROL_TYPE_INPUT, MATCH_HIDDEN, MATCH_VISIBLE } from '@ng-dynamic-forms/core';
import { compareProps } from '../../helpers/compare-props.helper';
import { getDisplayName } from '../../helpers/display-name.helper';
import { MATCH_SELECT_VISIBLE } from '../../matchers/select-visible.matcher';
import { TYPE_CHIP_CHOICE_MULTIPLE } from '../chip-choice-multiple/chip-choice-multiple.model';
import { TYPE_CUSTOM_FILE_UPLOAD } from '../custom-file-upload/custom-file-upload.model';
import { AnyFormControlModel } from '../shared-models/any-form-control.model';

export function LENKER_AUSWAEHLEN_TEMPLATE_FACTORY(lenkerList: Lenker[]): AnyFormControlModel[] {
  return [
    {
      id:            'lenker',
      type:          'SELECT',
      label:         'Lenkerdatenauswahl',
      required:      true,
      value:         '',
      compareWithFn: compareProps.bind(null, ['kundeId']),
      options:       [
        ...lenkerList.map(value => ({
          label: getDisplayName([
            value.vorname,
            value.nachname
          ]),
          value
        })),
        {
          label: 'Lenkerdaten erfassen',
          value: 'A'
        },
        {
          label: 'Lenkerdaten werden nachgebracht',
          value: 'N'
        },
        {
          label: 'Der Lenker ist unbekannt',
          value: 'U'
        },
        {
          label: 'Es ist kein Lenker vorhanden',
          value: 'K'
        }
      ],
      errorMessages: {
        required: '{{ label }} ist ein Pflichtfeld.'
      }
    },
    {
      id:        'lenker_erfassen',
      type:      DYNAMIC_FORM_CONTROL_TYPE_GROUP,
      hidden:    true,
      relations: [
        {
          match: MATCH_VISIBLE,
          when:  [
            {
              id:    'lenker',
              value: 'A'
            }
          ]
        }
      ],
      group:     [
        {
          id:            'vorname',
          placeholder:   'Bitte geben Sie den Vornamen des Lenkers ein.',
          label:         'Vorname',
          validators:    {
            maxLength: 25
          },
          errorMessages: {
            alphanum:  'Bitte geben Sie einen gültigen Vornamen ein',
            maxLength: 'Bitte geben Sie maximal 25 Zeichen ein.'
          },
          type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
          value:         ''
        },
        {
          id:            'nachname',
          placeholder:   'Bitte geben Sie den Nachnamen des Lenkers ein.',
          label:         'Nachname',
          type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
          required:      true,
          validators:    {
            minLength: 2,
            required:  null,
            maxLength: 60
          },
          errorMessages: {
            minLength: 'Bitte geben Sie einen gültigen Nachnamen ein.',
            alphanum:  'Bitte geben Sie einen gültigen Nachnamen ein.',
            required:  '{{ label }} ist ein Pflichtfeld.',
            maxLength: 'Bitte geben Sie maximal 60 Zeichen ein.'
          }
        }
      ]
    },
    {
      id:        'lenker_erfassen_allgemein',
      type:      DYNAMIC_FORM_CONTROL_TYPE_GROUP,
      hidden:    true,
      relations: [
        {
          match: MATCH_HIDDEN,
          when:  [
            {
              id:    'lenker',
              value: 'N'
            },
            {
              id:    'lenker',
              value: 'U'
            },
            {
              id:    'lenker',
              value: 'K'
            },
            {
              id:    'lenker',
              value: ''
            }
          ]
        }
      ],
      group:     [
        {
          id:            'geburtsDatum',
          placeholder:   'Bitte geben Sie das Geburtsdatum des Lenkers ein.',
          label:         'Geburtsdatum',
          type:          DYNAMIC_FORM_CONTROL_TYPE_DATEPICKER,
          value:         '',
          required:      true,
          validators:    {
            required: null
          },
          errorMessages: {
            required: '{{ label }} ist ein Pflichtfeld.'
          }
        },
        {
          id:            'fuehrerscheinKlassen',
          type:          TYPE_CHIP_CHOICE_MULTIPLE,
          placeholder:   'Führerscheinklassen',
          required:      true,
          errorMessages: {
            required: '{{ placeholder }} ist ein Pflichtfeld.'
          },
          options:       [
            {
              label: 'AM',
              value: 'AM'
            },
            {
              label: 'A1',
              value: 'A1'
            },
            {
              label: 'A2',
              value: 'A2'
            },
            {
              label: 'A',
              value: 'A'
            },
            {
              label: 'B1',
              value: 'B1'
            },
            {
              label: 'B',
              value: 'B'
            },
            {
              label: 'C1',
              value: 'C1'
            },
            {
              label: 'C',
              value: 'C'
            },
            {
              label: 'D1',
              value: 'D1'
            },
            {
              label: 'D',
              value: 'D'
            },
            {
              label: 'BE',
              value: 'BE'
            },
            {
              label: 'C1E',
              value: 'C1E'
            },
            {
              label: 'CE',
              value: 'CE'
            },
            {
              label: 'D1E',
              value: 'D1E'
            },
            {
              label: 'DE',
              value: 'DE'
            },
            {
              label: 'F',
              value: 'F'
            }
          ]
        },
        {
          id:           'fuehrerscheinRueckseite',
          type:         TYPE_CUSTOM_FILE_UPLOAD,
          labelTooltip: 'Führerscheinrückseite für Klasse "AM" hinzufügen',
          relations:    [
            {
              match: MATCH_SELECT_VISIBLE,
              when:  [
                {
                  id:    'fuehrerscheinKlassen',
                  value: ['AM']
                }
              ]
            }
          ]
        }
      ]
    }
  ];
}
